import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import keys from 'lodash/keys';

import styles from './Icon.module.scss';

import iconCfd from './assets/cfd-badge-75x75.png';
import icon3dsMax from './assets/3ds-max-badge-75x75.png';
import iconFusion360 from './assets/fusion-360-badge-75x75.png';
import iconForge from './assets/forge-badge-75x75.png';
import iconDynamo from './assets/dynamo-studio-badge-75x75.png';
import iconInventor from './assets/inventor-badge-75x75.png';
import iconRevit from './assets/revit-badge-75x75.png';
import iconPlangrid from './assets/plangrid-badge-75x75.png';
import iconMaya from './assets/maya-badge-75x75.png';
import iconCivil3d from './assets/civil-3d-badge-75x75.png';
import iconShotgun from './assets/shotgun-badge-75x75.png';
import iconInfraworks from './assets/infraworks-badge-75x75.png';
import iconAutocad from './assets/autocad-badge-75x75.png';
import iconBim360 from './assets/bim-360-badge-75x75.png';
import iconNavisworks from './assets/navisworks-badge-75x75.png';
import iconAlias from './assets/alias-badge-75x75.png';

import iconFb from './assets/facebook-24.svg';
import iconLinkedIn from './assets/linkedin-24.svg';
import iconTwitter from './assets/twitter-24.svg';
import iconBlog from './assets/blog-24.svg';
import iconInstagram from './assets/instagram-24.svg';
import iconYoutube from './assets/youtube-24.svg';
import iconShare from './assets/share-24.svg';
import iconLink from './assets/link.svg';
import iconSearch from './assets/search.svg';
import iconArrowRightGrey from './assets/caret-down-16.svg';

const TYPES = {
  cfd: iconCfd,
  '3dsMax': icon3dsMax,
  fusion360: iconFusion360,
  forge: iconForge,
  dynamo: iconDynamo,
  inventor: iconInventor,
  revit: iconRevit,
  planGrid: iconPlangrid,
  maya: iconMaya,
  civil3d: iconCivil3d,
  shotgun: iconShotgun,
  infraworks: iconInfraworks,
  autocad: iconAutocad,
  bim360: iconBim360,
  navisworks: iconNavisworks,
  alias: iconAlias,

  facebook: iconFb,
  linkedIn: iconLinkedIn,
  twitter: iconTwitter,
  link: iconLink,
  blog: iconBlog,
  instagram: iconInstagram,
  youtube: iconYoutube,
  share: iconShare,
  search: iconSearch,
  arrowRightGrey: iconArrowRightGrey,
};

export const Icon = ({type, size, className}) => {
  return (
    <div
      className={cn(styles.wrap, className, {[styles.large]: size === 'large'})}
    >
      <img src={TYPES[type]} alt="" />
    </div>
  );
};

Icon.propTypes = {
  type: PropTypes.oneOf(keys(TYPES)).isRequired,
  size: PropTypes.oneOf(['normal', 'large']),
  className: PropTypes.string,
};

Icon.defaultProps = {
  size: 'normal',
  className: null,
};
